(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-no-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.videoNoControlsPlayReady) return;
    window.videoNoControlsPlayReady = true;

    const getVideo = (wrapper) => wrapper && wrapper.querySelector('video.video-no-controls');

    // Delegated, so it also works for blocks re-rendered by the theme editor and carousel clones.
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-video-no-controls-play]');
      if (!button) return;
      event.preventDefault();
      const video = getVideo(button.closest('.video-no-controls-wrapper'));
      if (!video) return;
      if (video.paused || video.ended) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    // Media events do not bubble, so they are listened to in the capture phase.
    const syncState = (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement) || !video.classList.contains('video-no-controls')) return;
      const wrapper = video.closest('.video-no-controls-wrapper--play');
      if (!wrapper) return;
      const playing = event.type === 'play' || event.type === 'playing';
      wrapper.classList.toggle('is-playing', playing);
      const button = wrapper.querySelector('[data-video-no-controls-play]');
      if (button) button.setAttribute('aria-label', playing ? button.dataset.labelPause : button.dataset.labelPlay);
    };
    ['play', 'playing', 'pause', 'ended'].forEach((type) => document.addEventListener(type, syncState, true));
  })();
  } catch(e) { console.error(e); }
})();

})();
